export default __webpack_public_path__ + "static/article-renovation-avoid-common-painting-mistakes-39f6f0e2f70d6a05c9be306ab2f4c8f0.jpg";